// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.soundMeter__Ua8fmiw0fO{width:100%;overflow:hidden;position:relative;height:16px}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/soundMeter/soundMeter.module.scss"],"names":[],"mappings":"AAAA,wBACE,UAAA,CACA,eAAA,CACA,iBAAA,CACA,WAAA","sourcesContent":[".soundMeter {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"soundMeter": `soundMeter__Ua8fmiw0fO`
};
export default ___CSS_LOADER_EXPORT___;
